import React from 'react';
import { Phone, Mail, MessageCircle } from 'lucide-react';
import { contactInfo } from '../data/mock';
import { useLanguage } from '../context/LanguageContext';

const Contact = () => {
  const { t, language } = useLanguage();
  
  const contactMethods = [
    {
      icon: Phone,
      label: t.contact.phone,
      value: contactInfo.phone,
      href: `tel:${contactInfo.phone.replace(/\s/g, '')}`,
    },
    {
      icon: Mail,
      label: t.contact.email,
      value: contactInfo.email,
      href: `mailto:${contactInfo.email}`,
    },
    {
      icon: MessageCircle,
      label: t.contact.whatsapp,
      value: language === 'en' ? 'Send a message' : 'Pošaljite poruku',
      href: `https://wa.me/${contactInfo.whatsapp}`,
    },
  ];

  return (
    <section id="kontakt" className="py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <p className="text-amber-400 text-sm font-medium tracking-wider mb-2">{t.contact.subtitle}</p>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white">
            {t.contact.title}
          </h2>
        </div>

        {/* Contact Cards */}
        <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {contactMethods.map((method, index) => (
            <a
              key={index}
              href={method.href}
              target={method.label === t.contact.whatsapp ? '_blank' : undefined}
              rel={method.label === t.contact.whatsapp ? 'noopener noreferrer' : undefined}
              className="bg-gray-800 hover:bg-gray-700 rounded-2xl p-6 text-center transition-all duration-300 group hover:scale-105"
            >
              <div className="bg-amber-700 w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-amber-600 transition-colors duration-300">
                <method.icon size={24} className="text-white" />
              </div>
              <h3 className="text-white font-bold mb-2">{method.label}</h3>
              <p className="text-gray-400 text-sm">{method.value}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Contact;
